import { useQuery } from '@tanstack/react-query'

import { medicalSheetInstance } from '@/modules/medicalRecord'

export function getProfileClientMedicalSheetQueryKey(patientId?: string) {
  const baseKey = 'patientMedicalRecord'
  return patientId ? [baseKey, patientId] : [baseKey]
}

export function useProfileClientMedicalSheetQuery({
  patientId
}: {
  patientId: string
}) {
  return useQuery({
    queryKey: getProfileClientMedicalSheetQueryKey(patientId),
    queryFn: async () => {
      const response =
        await medicalSheetInstance.getProfilePatientMedicalRecord(patientId)
      return response
    },
    enabled: Boolean(patientId)
  })
}
